import React, { useState } from "react";

import {
    Truck,
    Plus,
    Trash2
} from "lucide-react";


const Vehicles = () => {

    const [vehicles, setVehicles] =
        useState([]);

    const [vehicleNo, setVehicleNo] =
        useState("");


    const addVehicle = () => {

        if (!vehicleNo.trim()) {
            return;
        }


        setVehicles([
            ...vehicles,
            {
                id: Date.now(),
                vehicleNo:
                    vehicleNo.trim()
            }
        ]);


        setVehicleNo("");

    };


    const removeVehicle = id => {

        setVehicles(
            vehicles.filter(
                item => item.id !== id
            )
        );

    };


    return (
        <div className="page-container">

            <div className="page-header">

                <div>

                    <h2>
                        Vehicles
                    </h2>

                    <p>
                        Vehicle records
                    </p>

                </div>

            </div>


            <div className="content-card">

                <div className="form-inline">

                    <input
                        placeholder="Vehicle number"
                        value={vehicleNo}
                        onChange={e =>
                            setVehicleNo(
                                e.target.value
                            )
                        }
                    />

                    <button
                        className="primary-button"
                        onClick={addVehicle}
                    >
                        <Plus size={16} />
                        Add
                    </button>

                </div>

            </div>


            <div className="content-card">

                {vehicles.length === 0 ? (

                    <div className="empty-state">
                        <Truck />
                        <p>
                            No vehicles added.
                        </p>
                    </div>

                ) : (

                    <div className="table-wrapper">

                        <table>

                            <thead>

                                <tr>
                                    <th>Vehicle No.</th>
                                    <th>Action</th>
                                </tr>

                            </thead>


                            <tbody>

                                {vehicles.map(
                                    vehicle => (

                                        <tr
                                            key={
                                                vehicle.id
                                            }
                                        >

                                            <td>
                                                {vehicle.vehicleNo}
                                            </td>

                                            <td>

                                                <button
                                                    className="icon-button danger"
                                                    onClick={() =>
                                                        removeVehicle(
                                                            vehicle.id
                                                        )
                                                    }
                                                >
                                                    <Trash2
                                                        size={16}
                                                    />
                                                </button>

                                            </td>

                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>

                )}

            </div>

        </div>
    );
};


export default Vehicles;